import { Configuration } from "@mwt/web-js-telemetry";

export const telemetryClientConfig: Configuration = {
  instrumentationKey: undefined,
  channelConfiguration: {
    // Post channel configuration
    eventsLimitInMem: 50,
    enableCompoundKey: true,
  },
  webAnalyticsConfiguration: {
    // Web Analytics Plugin configuration
    autoCapture: {
      scroll: false,
      pageView: false,
      onLoad: false,
      onUnload: false,
      click: false,
      resize: false,
      jsError: false,
    },
  },
};

// Its recommended to use a new object when doing a update
export const telemetryClientForReConfig: Configuration = {
  instrumentationKey: undefined,
  channelConfiguration: {
    // Post channel configuration
    eventsLimitInMem: 50,
    enableCompoundKey: true,
  },
  webAnalyticsConfiguration: {
    // Web Analytics Plugin configuration
    autoCapture: {
      scroll: false,
      pageView: false,
      onLoad: false,
      onUnload: false,
      click: false,
      resize: false,
      jsError: false,
    },
  },
};
